import './info.scss';
import React, {useEffect} from "react";
import {CountryBox} from "../country/box.js";
import {CountryHeader} from "../country/header.js";
import {useStateContext} from "../../helpers/state-context.js";
import {infoMapping} from "./info-mapping.js";

const Info = function (props) {
    const [state,dispatch] = useStateContext()
    useEffect(() => {
        const handleClickOutside = (e) => {
            const container = document.getElementsByClassName('country-box');
            const header = document.getElementsByClassName('info-header');
            const moreButtons = document.getElementById('more-buttons');
            const wrapper = document.getElementsByClassName('info-wrapper')[0];

            const isOutside = [...container, ...header, moreButtons].every((box)=>(box && !box.contains(e.target)));
            if(isOutside && wrapper){
                e.stopPropagation();
                if(props.onClose){
                    props.onClose();
                }
                dispatch({type: 'country', value: null});
                dispatch({type: 'page', value: null});
                dispatch({type: 'setDefaultCategories'});
            }

        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        }
    }, [dispatch, props]);


    return <div className={'info-wrapper'}>
        <div className={'info-container'}>
            <CountryHeader classNamePrefix={'info'} title={'Information'} onClose={props.onClose}/>
            <div className={'country'}>
                <div style={{flex: 1}}>
                    {infoMapping.map((info, key)=>{
                        return <CountryBox key={key}
                                           expandable
                                           expanded={state.infoExpanded[key]}
                                           onToggle={(bool)=>{
                                               let infoExpanded = [...state.infoExpanded]
                                               infoExpanded[key] = bool;
                                               dispatch({type: 'infoExpanded', value: infoExpanded})
                                           }}
                                           {...info}/>
                    })}
            </div>
        </div>
        </div>
        </div>
}

Info.defaultProps = {

}

export {Info}